import script from "./fundHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./fundHistory.vue?vue&type=script&setup=true&lang=ts"

import "./fundHistory.vue?vue&type=style&index=0&id=cf887424&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf887424"]])

export default __exports__